import Plot from 'react-plotly.js'

interface WaterfallItem {
  label: string
  value: number
  type?: 'relative' | 'total'
}

interface WaterfallChartProps {
  data: WaterfallItem[]
  title?: string
  height?: number
  positiveColor?: string
  negativeColor?: string
  totalColor?: string
  className?: string
}

export default function WaterfallChart({
  data,
  title,
  height = 300,
  positiveColor = '#10b981',
  negativeColor = '#ef4444',
  totalColor = '#3b82f6',
  className
}: WaterfallChartProps) {
  const measures = data.map(item => item.type || 'relative')
  const xValues = data.map(item => item.label)
  const yValues = data.map(item => item.value)

  const trace = {
    type: 'waterfall' as const,
    orientation: 'v' as const,
    measure: measures,
    x: xValues,
    y: yValues,
    textposition: 'outside' as const,
    text: yValues.map(v => {
      const sign = v >= 0 ? '+' : ''
      return `${sign}${v.toFixed(1)}%`
    }),
    textfont: { color: '#94a3b8', size: 10 },
    connector: {
      line: { color: '#475569', width: 1, dash: 'dot' }
    },
    increasing: { marker: { color: positiveColor } },
    decreasing: { marker: { color: negativeColor } },
    totals: { marker: { color: totalColor } }
  }

  const layout = {
    title: title ? {
      text: title,
      font: { color: '#e2e8f0', size: 14 }
    } : undefined,
    height,
    margin: { t: title ? 40 : 20, r: 20, b: 60, l: 50 },
    paper_bgcolor: 'transparent',
    plot_bgcolor: 'transparent',
    font: { color: '#94a3b8', family: 'Inter, sans-serif' },
    xaxis: {
      tickangle: -45,
      tickfont: { size: 10 },
      gridcolor: '#334155'
    },
    yaxis: {
      title: { text: 'Contribution (%)', font: { color: '#94a3b8', size: 12 } },
      tickfont: { size: 10 },
      gridcolor: '#334155',
      zeroline: true,
      zerolinecolor: '#475569'
    },
    showlegend: false
  }

  const config = {
    displayModeBar: false,
    responsive: true
  }

  return (
    <div className={className}>
      <Plot
        data={[trace]}
        layout={layout}
        config={config}
        style={{ width: '100%' }}
      />
    </div>
  )
}
